import React from 'react';
import { DarkModeProvider, DarkModeToggle } from './components/DarkMode';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Overview from './components/Overview';
import Technology from './components/Technology';
import Impact from './components/Impact';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ParticlesBackground from './components/ParticlesBackground';
import './styles/App.css';

function App() {
  return (
    <DarkModeProvider>
      <div className="App">
        <ParticlesBackground />

        {/* Dark Mode Toggle */}
        <DarkModeToggle />

        {/* Scroll to Top Button */}
        <ScrollToTop />

        <Navbar />
        <Hero />
        <Overview />
        <Technology />
        <Impact />
        <Team />
        <Contact />
        <Footer />
      </div>
    </DarkModeProvider>
  );
}

export default App;
